import React, { useState, useEffect } from "react";
import { useDispatch } from 'react-redux'
import { Button, Modal, Tooltip } from "flowbite-react"
import { HiOutlineTrash, HiOutlineMinus, HiOutlinePlus } from "react-icons/hi";
import { FaQuestionCircle } from 'react-icons/fa';
import { MdFilterList } from 'react-icons/md';
import { openSnackBar } from '../../redux/snackBarReducer';
import swal from 'sweetalert2';
import styled from 'styled-components';
import Select from 'react-tailwindcss-select';
import SortItem from './SortItem';
import { useTranslation } from "react-i18next";

export const SelectCustomStyle = styled.div`
.flex.text-sm.text-gray-500.border.border-gray-300.rounded.shadow-sm.transition.duration-300{
    height: 42px;
    width: 200px;
}
`

function SortModal(props) {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const [modalShow, setModalShow] = useState(false);    //modal modalShow hide
    const [mainAttr, setMainAttr] = useState({ value: 0, label: t("product-category") });
    const [mainOrder, setMainOrder] = useState({ value: 2, label: t("classic") });
    const [mainCheck, setMainCheck] = useState(true);
    const [mainCheckVisible, setMainCheckVisible] = useState(true);
    const [main_order_options, setMainOrderOptions] = useState([]);
    const [otherAttr, setOtherAttr] = useState({ value: 7, label: t("product-name") });
    const [otherOrder, setOtherOrder] = useState({ value: 0, label: t("alpha-a-z") });
    const [otherCheck, setOtherCheck] = useState(false);
    const [otherCheckVisible, setOtherCheckVisible] = useState(true);
    const [other_order_options, setOtherOrderOptions] = useState([]);
    const [sort_array, setSortArray] = useState([
        {attr: { value: 1, label: t("product-sub-category") }, order: { value: 2, label: t("classic") }, is_group: true},
        {attr: { value: 2, label: t("wine_color") }, order: { value: 2, label: t("classic") }, is_group: true},
        {attr: { value: 3, label: t("country") }, order: { value: 2, label: t("north_to_south") }, is_group: false},
        {attr: { value: 4, label: t("region") }, order: { value: 2, label: t("north_to_south") }, is_group: false},
        {attr: { value: 6, label: t("producer") }, order: { value: 0, label: t("alpha-a-z") }, is_group: false},
    ]);

    var sortType = [t("product-category"), t("product-sub-category"), t("wine_color"), t("country"), t("region"), t("sub-region"), t("producer"), t("product-name"), t("grape-variaty")];
    var orderType = [t("alpha-a-z"), t("alpha-z-a"), t("classic")]

    useEffect(() => {
        let order = [];
        orderType && orderType.map((data, index) => {
            order[index] = { value: index, label: data }
        });
        setMainOrderOptions(order);
        // setOtherOrderOptions(order);
    }, [])

    var sort_options = [];

    sortType && sortType.map((data, index) => {
        sort_options[index] = { value: index, label: data }
    });

    //////////////main sort info/////////////////////////////////
    const selectMainAttr = (value) => {
        let flag = false;
        sort_array.map(data => {
            if (data.attr.value === value.value)
                flag = true
        })
        if (mainAttr?.value === value.value) {
            flag = true;
        }

        if (!flag) {
            setMainAttr(value);

            if (value.value === 7) {   //if product name dont show the group check
                setMainCheckVisible(false);
                setMainCheck(false);

                if (sort_array.length > 0) {
                    sort_array.map((sort, index) => {
                        sort_array[index].is_group = false;
                    })
                    setSortArray([...sort_array]);
                }
            } else {
                setMainCheckVisible(true);
            }

            if (value.value < 3) {
                orderType = [t("alpha-a-z"), t("alpha-z-a"), t("classic")];
            } else if (value.value < 7) {
                orderType = [t("alpha-a-z"), t("alpha-z-a"), t("north_to_south")];
            } else {
                orderType = [t("alpha-a-z"), t("alpha-z-a")];
            }

            let order = [];

            orderType && orderType.map((data, index) => {
                order[index] = { value: index, label: data }
            });

            setMainOrderOptions(order);
            setMainOrder(order[0]);
        } else {
            dispatch(openSnackBar({ status: "error", message: t("msg_already_exist") }));
        }
    }

    const setSortArrayFromItem = (data) => {// need for select the product name sort
        setSortArray([...data]);
        setOtherAttr("");
        setOtherOrder("");
        setOtherOrderOptions([]);
        setOtherCheck(false);
    }

    const selectMainOrder = (value) => {
        setMainOrder(value);
    }

    const clickMainCheck = () => {
        if (sort_array.length > 0) {
            if (sort_array[0].is_group) {
                dispatch(openSnackBar({ status: "error", message: t("msg_uncheck_all") }));
            } else {
                setMainCheck(!mainCheck);
            }
        } else {
            setMainCheck(!mainCheck);
        }
    }

    ////////////////////other sort info///////////////////////////////////
    const selectOtherAttr = (value) => {
        setOtherAttr(value);

        if (value.value === 7) {   //if product name dont show the group check
            setOtherCheckVisible(false);
            setOtherCheck(false);
        } else {
            setOtherCheckVisible(true);
        }

        if (value.value < 3) {
            orderType = [t("alpha-a-z"), t("alpha-z-a"), t("classic")];
        } else if (value.value < 7) {
            orderType = [t("alpha-a-z"), t("alpha-z-a"), t("north_to_south")];
        } else {
            orderType = [t("alpha-a-z"), t("alpha-z-a")];
        }

        let order = [];

        orderType && orderType.map((data, index) => {
            order[index] = { value: index, label: data }
        });

        setOtherOrderOptions(order);
        setOtherOrder(order[0]);
    }

    const selectOtherOrder = (value) => {
        setOtherOrder(value);
    }

    const clickOtherCheck = () => {
        if (mainAttr.value === 7) { // product
            dispatch(openSnackBar({ status: "error", message: t("msg_cant_check_bcos_product_name") }));
        } else {
            if (mainCheck) {
                if (sort_array.length > 0) {
                    if (sort_array[sort_array.length - 1].is_group) {
                        setOtherCheck(!otherCheck);
                    } else {
                        dispatch(openSnackBar({ status: "error", message: t("msg_check_prev_item") }));
                    }
                } else {
                    setOtherCheck(!otherCheck);
                }
            } else {
                dispatch(openSnackBar({ status: "error", message: t("msg_check_main_item") }));
            }
        }
    }

    //////////////////////exist sort info//////////////////////////////
    const selectExistAttr = (value, pos) => {
        sort_array[pos].attr = value;
        setSortArray([...sort_array]);
    }

    const selectExistOrder = (value, pos) => {
        sort_array[pos].order = value
        setSortArray([...sort_array]);
    }

    const clickExistCheck = (value, pos) => {
        sort_array[pos].is_group = value;
        setSortArray([...sort_array]);
    }

    const addSort = () => {
        if (mainAttr && mainOrder) {
            if (otherAttr && otherOrder) {
                let flag = false;
                sort_array.map(data => {
                    if (data.attr.value === otherAttr.value)
                        flag = true
                })
                if (mainAttr?.value === otherAttr.value) {
                    flag = true;
                }

                if (!flag) {
                    setSortArray([...sort_array, { attr: otherAttr, order: otherOrder, is_group: otherCheck }]);
                    removeSort();
                } else {
                    dispatch(openSnackBar({ status: "error", message: t("msg_already_exist") }));
                }
            } else {
                if (!otherAttr) {
                    dispatch(openSnackBar({ status: "error", message: t("msg_select_attribute") }));
                } else if (!otherOrder) {
                    dispatch(openSnackBar({ status: "error", message: t("msg_select_order") }));
                }
            }
        } else {
            if (!mainAttr) {
                dispatch(openSnackBar({ status: "error", message: t("msg_select_main_attribute") }));
            } else if (!mainOrder) {
                dispatch(openSnackBar({ status: "error", message: t("msg_select_main_order") }));
            }
        }
    }

    const removeSort = () => {
        setOtherAttr("");
        setOtherOrder("");
        setOtherOrderOptions([]);
        setOtherCheck(false);
    }

    const removeSortItem = (pos) => {
        swal.fire({
            title: t("swal_are_you_sure"),
            text: t("swal_remove_sort"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t("swal_remove")
        })
            .then(result => {
                if (result.isConfirmed) {
                    sort_array.splice(pos, 1)
                    setSortArray([...sort_array]);
                }
            });
    }

    const closeModal = () => {
        swal.fire({
            title: t("swal_are_you_sure"),
            text: t("swal_leave_page"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t("swal_leave")
        })
            .then(result => {
                if (result.isConfirmed) {
                    close();
                }
            });
    }

    function close() {
        setModalShow(false);
        setMainAttr("");
        setMainOrder("");
        setMainCheck(false);
        removeSort();
        setSortArray([]);
    }

    const clearSort = () => {
        removeSort();
        setMainAttr("");
        setMainOrder("");
        setMainCheck(false);
        setSortArray([]);
    }

    const applySort = () => {
        if (mainAttr && mainOrder) {
            swal.fire({
                title: t("swal_are_you_sure"),
                text: t("swal_apply_sort"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtnColor: '#d33',
                confirmButtonText: t("swal_apply")
            })
                .then(result => {
                    if (result.isConfirmed) {
                        if (otherAttr) {
                            props.setData([{ attr: mainAttr, order: mainOrder, is_group: mainCheck }, ...sort_array, { attr: otherAttr, order: otherOrder, is_group: otherCheck }])
                        } else {
                            props.setData([{ attr: mainAttr, order: mainOrder, is_group: mainCheck }, ...sort_array])
                        }
                        close();
                    }
                });
        } else {
            dispatch(openSnackBar({ status: "error", message: t("msg_cant_sort_bcos_main") }));
        }
    }


    return (
        <>
            {/* <Button onClick={() => setModalShow(true)} outline={true} className="bg-sitebg-50" >
                <MdFilterList className="mr-2 h-6 w-6 text-sitebg-50" />
                {t("create_new_wine_menu")}
            </Button> */}
            <Button color={'red'} onClick={() => setModalShow(true)} outline={false} className="bg-indigo-500 text-white hover:bg-indigo-400 w-500 flex-system-space-around py-1" style={{width:'240px'}} >
                {/* <HiOutlineDocumentAdd className="mr-2 h-6 w-6 text-white" /> */}
                {/* <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="mr-2 h-4 w-4 text-white" stroke-width="1.5">
                    <path d="M16.5,21.513a1.5,1.5,0,0,1-1.9,1.446L4.1,20.042A1.5,1.5,0,0,1,3,18.6V2.487A1.5,1.5,0,0,1,4.9,1.041L15.4,4.432a1.5,1.5,0,0,1,1.1,1.445Z" fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M4.5.987h15a1.5,1.5,0,0,1,1.5,1.5v15.75a1.5,1.5,0,0,1-1.5,1.5h-3" fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg> */}
                <svg className="mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5">
                    <path stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M21.75 5.25H2.25004C1.45004 5.25 0.750038 4.55 0.750038 3.75V2.25C0.750038 1.45 1.45004 0.75 2.25004 0.75H21.75C22.55 0.75 23.25 1.45 23.25 2.25V3.75C23.25 4.55 22.55 5.25 21.75 5.25Z"/>
                    <path stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M16.75 14.25H2.25004C1.45004 14.25 0.750038 13.55 0.750038 12.75V11.25C0.750038 10.45 1.45004 9.75 2.25004 9.75H16.75C17.55 9.75 18.25 10.45 18.25 11.25V12.75C18.25 13.55 17.55 14.25 16.75 14.25Z"/>
                    <path stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M11.75 23.25H2.25004C1.45004 23.25 0.750038 22.55 0.750038 21.75V20.25C0.750038 19.45 1.45004 18.75 2.25004 18.75H11.75C12.55 18.75 13.25 19.45 13.25 20.25V21.75C13.25 22.55 12.55 23.25 11.75 23.25Z"/></svg>
                {t("group_sort_product")}
            </Button>
            <Modal
                show={modalShow}
                size="3xl"
                popup={true}
                onClose={() => closeModal()}
            >
                <Modal.Header className="px-6 py-5">
                    {t("group_sort_product")}
                </Modal.Header>
                <hr />
                <Modal.Body>
                    <div className="py-6">
                        <div>
                            <div className="grid gap-4 align-middle pb-2" style={{ gridTemplateColumns: "1.5fr 3fr 2.5fr 2fr" }}>
                                <div className="m-2 ml-2 text-sm block"></div>
                                <div className="m-2 ml-2 text-sm font-bold block text-sitetx-200">{t("attribute")}</div>
                                <div className="m-2 ml-2 text-sm font-bold block text-sitetx-200">{t("order")}</div>
                                <div className="m-2 ml-2 text-sm font-bold flex text-sitetx-200">{t("group")}
                                    <Tooltip
                                        style="dark"
                                        content={t("menu_edit_sort_help")}
                                        placement="top"
                                        arrow={true}
                                        trigger="hover"
                                    >
                                        <FaQuestionCircle className="ml-2 w-4 h-4 my-auto text-orange-500" />
                                    </Tooltip>
                                </div>
                                {/* <div className="m-2 ml-2 text-sm block"></div> */}
                            </div>
                            <div className="grid gap-4 align-middle pb-2" style={{ gridTemplateColumns: "1.5fr 3fr 3fr 0.5fr 1fr" }}>
                                <div className="m-auto text-sm font-bold block text-sitetx-200">{t("sort_for")}:</div>
                                <div className="m-2 ml-2 text-sm font-bold block text-sitetx-200">
                                    <div>
                                        <SelectCustomStyle>
                                            <Select
                                                value={mainAttr}
                                                onChange={value => selectMainAttr(value)}
                                                options={sort_options}
                                            />
                                        </SelectCustomStyle>
                                    </div>
                                </div>
                                <div className="m-2 ml-2 text-sm font-bold block text-sitetx-200">
                                    <div>
                                        <SelectCustomStyle>
                                            <Select
                                                value={mainOrder}
                                                onChange={value => selectMainOrder(value)}
                                                options={main_order_options}
                                            />
                                        </SelectCustomStyle>
                                    </div>
                                </div>
                                <input type="checkbox" onChange={() => clickMainCheck()} checked={mainCheck} className={`${mainCheckVisible ? "visible" : "collapse"} w-4 h-4 m-auto text-blue-600 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600`} />
                                <div className="m-2 ml-2 text-sm font-bold block text-sitetx-200"></div>
                            </div>
                            {
                                sort_array?.length > 0 && sort_array.map((sort, index) =>
                                    <SortItem
                                        sort_array={sort_array}
                                        mainAttr={mainAttr}
                                        mainCheck={mainCheck}
                                        mainCheckVisible={mainCheckVisible}
                                        setArray={setSortArrayFromItem}
                                        key={index}
                                        data={sort}
                                        remove={removeSortItem}
                                        setAttr={selectExistAttr}
                                        setOrder={selectExistOrder}
                                        setGroup={clickExistCheck}
                                        pos={index}
                                    />
                                )
                            }
                            <div className="grid gap-4 align-middle pb-2" style={{ gridTemplateColumns: "1.5fr 3fr 3fr 0.5fr 1fr" }}>
                                <div className="m-auto text-sm font-bold block text-sitetx-200">{t("and_then")}</div>
                                <div className="m-2 ml-2 text-sm font-bold block text-sitetx-200">
                                    <div>
                                        <SelectCustomStyle>
                                            <Select
                                                value={otherAttr}
                                                onChange={value => selectOtherAttr(value)}
                                                options={sort_options}
                                            />
                                        </SelectCustomStyle>
                                    </div>
                                </div>
                                <div className="m-2 ml-2 text-sm font-bold block text-sitetx-200">
                                    <div>
                                        <SelectCustomStyle>
                                            <Select
                                                value={otherOrder}
                                                onChange={value => selectOtherOrder(value)}
                                                options={other_order_options}
                                            />
                                        </SelectCustomStyle>
                                    </div>
                                </div>
                                <input type="checkbox" onChange={() => clickOtherCheck()} checked={otherCheck} className={`${otherCheckVisible ? "visible" : "collapse"} w-4 h-4 m-auto text-blue-600 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600`} />
                                <div onClick={() => removeSort()} className="m-2 text-sm font-bold block text-sitetx-200">
                                    <div className="bg-red-300 p-2 rounded-xl flex justify-center">
                                        <HiOutlineMinus className="w-6 h-6 text-red-500 visi" />
                                    </div>
                                </div>
                            </div>
                            <div onClick={() => addSort()} className="m-2 text-md font-bold block text-white">
                                <div className="bg-sitebg-50 bg-opacity-10 p-2 w-full h-14 rounded-xl flex justify-center items-center">
                                    {/* <HiOutlinePlus className="w-5 h-5 mr-2 text-sitebg-100" /> */}
                                    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mr-2 text-sitebg-100" viewBox="0 0 24 24" stroke-width="1.5px"><defs/><title>add-square</title><line x1="12" y1="7.5" x2="12" y2="16.5" fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round"/><line x1="7.5" y1="12" x2="16.5" y2="12" fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round"/><rect x="0.75" y="0.75" width="22.5" height="22.5" rx="3" ry="3" fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                    {t("add_sorting_level")}
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <hr />
                <Modal.Footer>
                    <div className="flex flex-wrap items-center gap-4 m-auto">
                        <div>
                            <Button onClick={() => clearSort()} color="red" outline={true} className="bg-white border-2 border-gray-300 bg-opacity-0 text-sitetx-100">
                                <HiOutlineTrash className="mr-2 h-5 w-5" />
                                {t("clear_sorting")}
                            </Button>
                        </div>
                        <div>
                            <Button onClick={() => applySort()} color="red" className="bg-indigo-500 text-white hover:!bg-indigo-400" >
                                {/* <MdFilterList className="mr-2 h-6 w-6 text-sitebg-50" /> */}
                                <svg className="mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5">
                                    <path stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M21.75 5.25H2.25004C1.45004 5.25 0.750038 4.55 0.750038 3.75V2.25C0.750038 1.45 1.45004 0.75 2.25004 0.75H21.75C22.55 0.75 23.25 1.45 23.25 2.25V3.75C23.25 4.55 22.55 5.25 21.75 5.25Z"/>
                                    <path stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M16.75 14.25H2.25004C1.45004 14.25 0.750038 13.55 0.750038 12.75V11.25C0.750038 10.45 1.45004 9.75 2.25004 9.75H16.75C17.55 9.75 18.25 10.45 18.25 11.25V12.75C18.25 13.55 17.55 14.25 16.75 14.25Z"/>
                                    <path stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M11.75 23.25H2.25004C1.45004 23.25 0.750038 22.55 0.750038 21.75V20.25C0.750038 19.45 1.45004 18.75 2.25004 18.75H11.75C12.55 18.75 13.25 19.45 13.25 20.25V21.75C13.25 22.55 12.55 23.25 11.75 23.25Z"/></svg>
                                {t("apply_sort")}
                            </Button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default SortModal;
